import { ColocaStatusPill } from "@/shared/components/data-display/ColocaStatusPill";
import useTranslations from "@/shared/lang/useTranslations";

import type { PaymentIncidentStatus } from "../types/paymentIncidents.types";
import { INCIDENT_STATUS_PILL, isIncidentOpen } from "../utils/paymentIncidents";

export interface IncidentStatusPillProps {
  status: PaymentIncidentStatus;
  /** The provider's name, already resolved for staff. */
  provider: string | null;
  size?: "default" | "sm";
  className?: string;
}

/** Where an incident stands, named after the provider it waits on. */
export function IncidentStatusPill({
  status,
  provider,
  size = "default",
  className,
}: IncidentStatusPillProps) {
  const { t } = useTranslations("paymentIncidents");
  return (
    <ColocaStatusPill
      variant={INCIDENT_STATUS_PILL[status]}
      withDot={isIncidentOpen(status)}
      size={size}
      className={className}
    >
      {t(`status_${status}`, { provider: provider ?? t("provider_fallback") })}
    </ColocaStatusPill>
  );
}
